import React from "react";
import Seal from "@/components/Seal";

// Branded header strip built from the official WECH-RB logo (replaces the old banner image).
export const BrandBanner = ({ className = "" }) => (
  <div
    className={`flex items-center gap-4 rounded-2xl border border-[var(--wechr-border)] bg-white px-6 py-5 shadow-[0_10px_30px_rgba(11,27,51,0.06)] ${className}`}
    data-testid="brand-banner"
  >
    <Seal size={64} />
    <div>
      <p className="font-heading text-2xl font-bold text-navy-900">
        WECH-RB <span className="align-middle text-sm font-medium text-wgreen-700">DD Certification</span>
      </p>
      <p className="mt-0.5 text-sm text-[var(--wechr-muted-text)]">
        We Create Harmony with Responsible Businesses — document-reviewed certification for EHS, ESG, ethics,
        anti-corruption, supplier due diligence &amp; AI governance.
      </p>
    </div>
  </div>
);

export default BrandBanner;
